import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { WebsiteAuditService } from '../../website-audit.service';
import { NotificationService } from 'src/app/core/services/notification.service';
import {
  suggestedLanguages,
  contriesWithLangs,
} from 'src/app/seo/onboarding/languages';

@Component({
  selector: 'app-add-task',
  templateUrl: './add-task.component.html',
  styleUrls: ['./add-task.component.css'],
})
export class AddTaskComponent {
  constructor(
    public dialogRef: MatDialogRef<AddTaskComponent>,
    private websiteAuditService: WebsiteAuditService,
    private notificationService: NotificationService,
  ) {}

  url: string = '';
  max_steps: string = '30';
  selectedDevice: string = 'mobile';
  selectedLanguage: string = '';
  selectedCountry: string = '';
  isAdding: boolean = false;
  suggestedCountries: any = contriesWithLangs.map((c: any) => {
    return c.country;
  });
  filteredLanguages: any = suggestedLanguages.map((l: any) => {
    return {
      name: l.name,
      value: l.value?.substring(0, 2),
    };
  });

  maxStepsOptions = [10, 30, 50, 100, 250, 500, 750, 1000];

  hideCountriesMAP: string[] = [];

  auditType: string = 'full_audit';
  auditFrequency: string = 'one time';
  auditTypes: any = [
    {
      name: 'Full Audit',
      value: 'full_audit',
    },
    {
      name: 'Agentic Ecommerce',
      value: 'crawl_only',
    },
  ];

  searchRegion(event: any) {
    const value = event.target.value;

    try {
      this.hideCountriesMAP = this.suggestedCountries
        .filter(
          (country: any) =>
            !country?.name?.toLowerCase().startsWith(value.toLowerCase()),
        )
        .map((c: any) => c.name);
    } catch (e) {
      this.hideCountriesMAP = [];
    }
  }

  addTask() {
    const proxyCode = (
      this.suggestedCountries.find((c: any) => c.name === this.selectedCountry)
        ?.code || ''
    ).toLowerCase();

    const params: any = {
      url: this.url,
      device: this.selectedDevice,
      language: this.selectedLanguage,
      country: this.selectedCountry,
      proxyCountryCode: proxyCode,
      auditFrequency: this.auditFrequency,
      // max_steps: this.max_steps,
    };

    if (this.auditType === 'crawl_only') {
      params['crawlOnly'] = true;
    }

    this.isAdding = true;
    this.websiteAuditService.addAuditTask(params).subscribe({
      next: (res) => {
        this.isAdding = false;
        if (res.status != 200) {
          this.notificationService.info(res?.message);
          return;
        }

        this.dialogRef.close(1);
      },
      error: (err) => {
        this.notificationService.error(err?.error?.message);
        this.isAdding = false;
      },
    });
  }

  public isDisabled() {
    // if (this.auditType === 'crawl_only') {
    //   return this.url.length === 0 || this.isAdding;
    // }

    return (
      this.url.length === 0 ||
      this.selectedLanguage.length === 0 ||
      this.selectedCountry.length === 0 ||
      this.isAdding
    );
  }
}
